import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLang } from '@/contexts/LanguageContext';
import { Lock, ArrowRight } from 'lucide-react';

/**
 * Shown to signed-in magic-link users (no password set) nudging them to
 * complete their profile so they unlock forum participation.
 * Renders nothing for signed-out visitors or full-password accounts.
 */
export default function UpgradeAccountBanner() {
  const { user } = useAuth();
  const { lang } = useLang();
  if (!user || user.has_password) return null;

  const tx = (en, ar) => (lang === 'ar' ? ar : en);

  return (
    <div className="max-w-4xl mx-auto px-4 pt-6" data-testid="upgrade-account-banner">
      <div className="glass-card rounded-2xl p-4 md:p-5 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-5 border border-sacred-gold/20">
        <div className="w-10 h-10 rounded-full bg-sacred-gold/10 flex items-center justify-center shrink-0">
          <Lock size={18} className="text-sacred-gold" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-heading font-body text-sm font-semibold mb-1">
            {tx("You're signed in — complete your profile", 'أنت مسجّل — أكمل ملفك الشخصي')}
          </p>
          <p className="text-text-muted/80 font-body text-xs leading-relaxed">
            {tx(
              'Set a password to join the forum and unlock full community access.',
              'أضف كلمة مرور للانضمام إلى المنتدى وفتح وصول كامل للمجتمع.'
            )}
          </p>
        </div>
        <Link
          to="/auth/set-password"
          className="gold-button px-4 py-2 rounded-full font-body text-xs flex items-center gap-1.5 whitespace-nowrap shrink-0"
          data-testid="upgrade-account-cta"
        >
          {tx('Set a password', 'أضف كلمة مرور')}
          <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
